import {
  Comparator,
  ComparatorProps,
  GraphComparisonApiService,
  GraphLegacyApiService,
  transformers,
  validators,
} from '@kizi/comparator-core';
import { ThemeProvider } from '@kizi/core-components';
import { layout, steps } from './config/machine.config';
import themeOsSample from './themes/os/theme';
import React from 'react';

export type StartWidgetProps = Partial<Omit<ComparatorProps, 'steps'>> & {
  steps?:
    | ComparatorProps['steps']
    | ((steps?: ComparatorProps['steps']) => ComparatorProps['steps']);
};

function StartWidget(props: StartWidgetProps) {
  const overriddenSteps =
    typeof props.steps === 'function' ? props.steps(steps) : steps;
  return (
    <ThemeProvider theme={themeOsSample}>
      <Comparator
        validators={validators}
        transformers={transformers}
        layout={[layout[0]]}
        name="os-triple-play"
        loadFn={() => import('./components/index')}
        {...props}
        steps={overriddenSteps}
        api={
          new GraphComparisonApiService<GraphLegacyApiService>(
            {
              baseUrl: process.env.KIZI_PUBLIC_GRAPH_API_BASE_URL ?? '',
              tokenUrl: process.env.KIZI_PUBLIC_API_ACCESS_TOKEN_URL ?? '',
              credentials: {
                token: '',
                clientId:
                  process.env.KIZI_PUBLIC_API_ACCESS_TOKEN_CLIENT_ID ?? '',
                clientSecret:
                  process.env.KIZI_PUBLIC_API_ACCESS_TOKEN_CLIENT_SECRET ?? '',
              },
            },
            GraphLegacyApiService,
          )
        }
      />
    </ThemeProvider>
  );
}

export default StartWidget;
